// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --container-width: 640px;
  --main-background-color: #f2f5f8;
  --itinerary-item-background-color: #fff;
  --font-color: #333;
  --alt-font-color: #fff;
  --main-background: url("/assets/bg.jpg");
  --amber: 255, 193, 7;
  --light-amber: 252, 248, 227;
  --dark-amber: 211, 158, 0;
  --dark-gray: 169, 169, 169;
  --green: 40, 167, 69;
  --light-green: 190, 228, 199;
  --dark-green: 30, 126, 52;
  --red: 217, 83, 79;
  --light-red: 242, 222, 222;
  --dark-red: 139, 33, 30;
  --border-color: #d7d7d7;
  --selection-background-color: #f6f6f6;
  --border-radius-size: 5px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 62.5%;
}

h1 {
  font-size: 2.4rem;
  font-weight: normal;
}

h2 {
  font-size: 1.8rem;
  font-weight: normal;
}

h3 {
  font-size: 1.6rem;
  font-weight: normal;
}

h4 {
  font-size: 1.3rem;
  font-weight: normal;
}

h5 {
  font-size: 1rem;
  font-weight: normal;
}

h6 {
  font-size: 0.8rem;
  font-weight: normal;
}

body {
  font-family:
    Lato,system-ui,Segoe UI,Cantarell,Noto Sans,
    BlinkMacSystemFont,
    -apple-system,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    "Fira Sans",
    "Droid Sans",
    sans-serif;
  font-size: 1.2rem;
  line-height: 1.5em;
  color: #333;
  color: var(--font-color);
}

.company-logo {
  display: block;
  margin: 10px auto 30px;
}

.company-logo.light {
    display: none;
  }

.company-logo.dark {
    display: none;
  }

.app {
  margin-left: auto;
  margin-right: auto;
}

.content {
  min-height: 95vh;
}

.content.error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.content.error h1 {
    margin-bottom: 1.5rem;
  }

.main-header {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 3px solid #000;
  min-height: 140px;
}

.main-header .subheader {
    font-size: 1em;
  }

.flash {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 1rem 3rem;
  border-radius: 5px;
  border-radius: var(--border-radius-size);
  max-width: 500px;
  text-align: center;
  transition: opacity 0.5s ease;
  z-index: 1;
}

.flash.success {
    background-color: rgb(190, 228, 199);
    background-color: rgb(var(--light-green));
    border: 1px solid rgb(40, 167, 69);
    border: 1px solid rgb(var(--green));
  }

.flash.error {
    background-color: rgb(242, 222, 222);
    background-color: rgb(var(--light-red));
    border: 1px solid rgb(217, 83, 79);
    border: 1px solid rgb(var(--red));
  }

.flash.hidden {
    opacity: 0;
    pointer-events: none;
  }

.input-error {
  color: rgb(217, 83, 79);
  color: rgb(var(--red));
}

.list {
  list-style-type: none;
}

.label .sub-label,
.detail .sub-label {
  font-size: 0.8em;
  color: #999;
}

.label .sub-label.required {
  color: #f00;
}

.input {
  padding: 10px;
  font-size: 1em;
}

.input.error:not(:focus) {
    border-color: rgb(217, 83, 79);
    border-color: rgb(var(--red));
  }

.button {
  display: block;
  outline: none;
  line-height: 3em;
  padding-left: 2em;
  padding-right: 2em;
  border: 1px solid #4cae4c;
  border-radius: 5px;
  border-radius: var(--border-radius-size);
  background: none;
  background-color: #5cb85c;
  text-transform: uppercase;
  cursor: pointer;
  color: white;
}

.button:disabled {
    border-color: #d7d7d7;
    border-color: var(--border-color);
    background-color: #ccc;
    color: #999;
  }

.confirmation {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;
  margin-bottom: 5px;
}

.confirmation .selection .label {
      display: block;
      padding: 0.5em 1em;
      border-top: 1px solid #d7d7d7;
      border-top: 1px solid var(--border-color);
      border-bottom: 1px solid #d7d7d7;
      border-bottom: 1px solid var(--border-color);
      border-left: 1px solid #d7d7d7;
      border-left: 1px solid var(--border-color);
      cursor: pointer;
      text-align: center;
      white-space: nowrap;
    }

.confirmation .selection .label:hover {
        background-color: #f6f6f6;
        background-color: var(--selection-background-color);
      }

.confirmation .selection .input {
      display: none;
    }

.confirmation .selection:first-child .label {
      border-top-left-radius: 5px;
      border-top-left-radius: var(--border-radius-size);
      border-bottom-left-radius: 5px;
      border-bottom-left-radius: var(--border-radius-size);
    }

.confirmation .selection:last-child .label {
      border-top-right-radius: 5px;
      border-top-right-radius: var(--border-radius-size);
      border-bottom-right-radius: 5px;
      border-bottom-right-radius: var(--border-radius-size);
      border-right: 1px solid #d7d7d7;
      border-right: 1px solid var(--border-color);
    }

.confirmation .selection .input:checked ~ .label {
      color: #fff;
      color: var(--alt-font-color);
    }

.confirmation .selection.confirm .input:checked ~ .label {
      background-color: rgb(40, 167, 69);
      background-color: rgb(var(--green));
      border: 1px solid rgb(30, 126, 52);
      border: 1px solid rgb(var(--dark-green));
    }

.confirmation .selection.unconfirm .input:checked ~ .label {
      background-color: rgb(255, 193, 7);
      background-color: rgb(var(--amber));
      border: 1px solid rgb(211, 158, 0);
      border: 1px solid rgb(var(--dark-amber));
    }

.confirmation .selection.reject .input:checked ~ .label {
      background-color: rgb(217, 83, 79);
      background-color: rgb(var(--red));
      border: 1px solid rgb(139, 33, 30);
      border: 1px solid rgb(var(--dark-red));
    }

.confirmation .selection.confirm .input:checked ~ .label:hover {
      background-color: rgb(190, 228, 199);
      background-color: rgb(var(--light-green));
      border: 1px solid rgb(40, 167, 69);
      border: 1px solid rgb(var(--green));
      color: #333;
      color: var(--font-color);
    }

.confirmation .selection.unconfirm .input:checked ~ .label:hover {
      background-color: rgb(252, 248, 227);
      background-color: rgb(var(--light-amber));
      border: 1px solid rgb(255, 193, 7);
      border: 1px solid rgb(var(--amber));
      color: #333;
      color: var(--font-color);
    }

.confirmation .selection.reject .input:checked ~ .label:hover {
      background-color: rgb(242, 222, 222);
      background-color: rgb(var(--light-red));
      border: 1px solid rgb(217, 83, 79);
      border: 1px solid rgb(var(--red));
      color: #333;
      color: var(--font-color);
    }

.confirmation.disabled {
    opacity: 0.5;
  }

.booking-alert-notice {
  background-color: #fff;
  background-color: var(--itinerary-item-background-color);
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #dc3545;
  border-radius: 5px;
  border-radius: var(--border-radius-size);
}

.booking-alert-notice::before {
    display: inline-block;
    content: "\\0021";
    border: 1px solid #dc3545;
    color: #dc3545;
    width: 1.5em;
    height: 1.5em;
    border-radius: 1em;
    text-align: center;
    margin-right: 10px;
  }

.booking-details {
  padding: 20px;
}

.table {
  display: table;
  width: 100%;
}

.table .table-cell,.table .table-cell-right {
    display: table-cell;
  }

.table .table-cell .user-guide,.table .table-cell-right .user-guide {
      display: block;
      margin-left: auto;
      width: -moz-fit-content;
      width: fit-content;
      margin-bottom: 20px;
    }

.table .table-cell .print-button,.table .table-cell-right .print-button {
      font-size: 90%;
      margin-left: auto;
      margin-right: 0;
      text-transform: none;
    }

.table .table-cell-right {
    vertical-align: bottom;
    width: 35%;
  }

.itinerary-item,
.invoice-rate,
.summary {
  padding-top: 20px;
  padding-bottom: 20px;
}

.itinerary-item,
.invoice-rate,
.booking-details,
.summary {
  margin-bottom: 20px;
}

.cancelled.itinerary-item,.cancelled.invoice-rate,.cancelled.booking-details,.cancelled.summary {
    color: rgb(169, 169, 169);
    color: rgb(var(--dark-gray));
  }

.cancelled.itinerary-item .deleted-at-timestamp,.cancelled.invoice-rate .deleted-at-timestamp,.cancelled.booking-details .deleted-at-timestamp,.cancelled.summary .deleted-at-timestamp {
      text-align: right;
      font-size: 80%;
      font-weight: bold;
    }

.itinerary-item .item-header,.invoice-rate .item-header,.booking-details .item-header,.summary .item-header {
    border-bottom: 1px solid #f2f5f8;
    border-bottom: 1px solid var(--main-background-color);
    padding-bottom: 10px;
    margin-bottom: 20px;
  }

.itinerary-item .item-header .core-detail,.invoice-rate .item-header .core-detail,.booking-details .item-header .core-detail,.summary .item-header .core-detail {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 10px;
    }

.itinerary-item .item-header .confirmation-reference .input,.invoice-rate .item-header .confirmation-reference .input,.booking-details .item-header .confirmation-reference .input,.summary .item-header .confirmation-reference .input,.itinerary-item .item-header .rejection-reason .input,.invoice-rate .item-header .rejection-reason .input,.booking-details .item-header .rejection-reason .input,.summary .item-header .rejection-reason .input {
      margin-bottom: 10px;
    }

.itinerary-item footer,.invoice-rate footer,.booking-details footer,.summary footer {
    border-top: 1px solid #f2f5f8;
    border-top: 1px solid var(--main-background-color);
    font-size: 90%;
    margin-top: 10px;
    padding-top: 10px;
  }

.itinerary-item h3,.invoice-rate h3,.booking-details h3,.summary h3,.itinerary-item .section,.invoice-rate .section,.booking-details .section,.summary .section {
    margin-bottom: 10px;
  }

.itinerary-item .guests h4,.invoice-rate .guests h4,.booking-details .guests h4,.summary .guests h4,.itinerary-item .supplier-notes h4,.invoice-rate .supplier-notes h4,.booking-details .supplier-notes h4,.summary .supplier-notes h4,.itinerary-item .medical-notes h4,.invoice-rate .medical-notes h4,.booking-details .medical-notes h4,.summary .medical-notes h4,.itinerary-item .treatments h4,.invoice-rate .treatments h4,.booking-details .treatments h4,.summary .treatments h4,.itinerary-item .meals h4,.invoice-rate .meals h4,.booking-details .meals h4,.summary .meals h4 {
    font-weight: bold;
  }

.itinerary-item .from-allocation,.invoice-rate .from-allocation,.booking-details .from-allocation,.summary .from-allocation {
    font-weight: bold;
  }

.itinerary-item .block,.invoice-rate .block,.booking-details .block,.summary .block {
    display: block;
  }

.cancelled {
  color: rgb(169, 169, 169);
  color: rgb(var(--dark-gray));
}

.supplier-prices {
  padding-bottom: 20px;
  border-bottom: 1px solid #f2f5f8;
  border-bottom: 1px solid var(--main-background-color);
}

.supplier-price {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.supplier-price .total {
    padding-left: 20px;
    text-align: right;
  }

.loading {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.submit-confirmations {
  margin-left: auto;
  margin-right: auto;
}

.footer {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 20px;
}

.rejection-reason .printable-version {
  display: none;
}

.treatments table,.meals table,.dinner-time table {
    margin: 1em 0;
    background-color: #f4f9f9;
    border-collapse: collapse;
    color: #838586;
  }

.treatments table th,.meals table th,.dinner-time table th {
      background-color: #333;
      background-color: var(--font-color);
      color: #fff;
      color: var(--alt-font-color);
      border-bottom: none !important;
    }

.treatments table th,.meals table th,.dinner-time table th,.treatments table td,.meals table td,.dinner-time table td {
      border: 1px solid #c4c8c9; 
      padding: 11px 8px;
      vertical-align: top;
      font-size: 90%;
      line-height: 1.3;
    }

.treatments table td.full-width,.meals table td.full-width,.dinner-time table td.full-width {
      width: 100%;
    }

.treatments table td.tbc,.meals table td.tbc,.dinner-time table td.tbc {
      background-color: #ffe5df;
    }

.treatments table td.zero-padding,.meals table td.zero-padding,.dinner-time table td.zero-padding {
      padding: 0;
    }

.treatments table td:nth-child(3) {
      white-space: nowrap;
    }

.meals table td:nth-child(3) {
      white-space: nowrap;
    }

.dinner-time table td:nth-child(3) {
      white-space: nowrap;
    }

.treatments table th:nth-child(-n + 3) {
      border-right: 1px solid #fff;
      border-right: 1px solid var(--alt-font-color);
    }

.meals table th:nth-child(-n + 3) {
      border-right: 1px solid #fff;
      border-right: 1px solid var(--alt-font-color);
    }

.dinner-time table th:nth-child(-n + 3) {
      border-right: 1px solid #fff;
      border-right: 1px solid var(--alt-font-color);
    }

.treatments table td:has(input:invalid) {
      background-color: #ffe5df;
      color: rgb(217, 83, 79);
      color: rgb(var(--red));
      border: 1px double rgb(217, 83, 79);
      border: 1px double rgb(var(--red));
    }

.meals table td:has(input:invalid) {
      background-color: #ffe5df;
      color: rgb(217, 83, 79);
      color: rgb(var(--red));
      border: 1px double rgb(217, 83, 79);
      border: 1px double rgb(var(--red));
    }

.dinner-time table td:has(input:invalid) {
      background-color: #ffe5df;
      color: rgb(217, 83, 79);
      color: rgb(var(--red));
      border: 1px double rgb(217, 83, 79);
      border: 1px double rgb(var(--red));
    }

.treatments table td.invalid,.meals table td.invalid,.dinner-time table td.invalid {
      background-color: #ffe5df;
      color: rgb(217, 83, 79);
      color: rgb(var(--red));
      border: 1px double rgb(217, 83, 79);
      border: 1px double rgb(var(--red));
    }

.treatments input,.meals input,.dinner-time input,.treatments select,.meals select,.dinner-time select {
    font-family: inherit;
    font-size: inherit;
    padding: 10px 8px;
    background: none;
    border: none;
    color: inherit;
  }

.treatments select,.meals select,.dinner-time select {
    margin-right: 8px;
  }

.dinner-time table {
  width: 100%;
}

.markdown h3 {
    font-size: 1.6rem;
    font-weight: 700 !important;
  }

.markdown p,.markdown ul {
    margin-bottom: 1em;
  }

.heading {
  font-weight: bold;
}

.heading :first-child {
    margin: 0
  }

.guests ul,.markdown ul {
    list-style-type: disc;
  }

.guests li,.markdown li {
    margin-left: 1.6em;
  }

.guests li p,.markdown li p {
      margin: 0;
    }

.inner-logo {
  display:none
}

body:has(.spabreaks) {
  padding-top: 20px;
}

body:has(.spabreaks) .app {
    background: #fbfaf8;
  }

body:has(.spabreaks) .company-logo {
    display: none;
  }

body:has(.spabreaks) .inner-logo {
    display: block;
    left: -17px;
    position: relative;
    top: -13px;
    margin-bottom: -8px;
  }

.spabreaks {
  padding-top: 20px;
}

.spabreaks h2 {
    font-weight: 500;
  }

.spabreaks h3 {
    font-weight: 500;
  }

.spabreaks .booking-details,.spabreaks .summary {
    border-radius: 5px;
    border-radius: var(--border-radius-size);
    position: relative;
  }

.spabreaks .booking-details .download-print,.spabreaks .summary .download-print {
      position: absolute;
      width: 50%;
      right: 6px;
      text-align: right;
    }

.spabreaks .summary .item-header {
      border: none;
      padding: 0;
      margin-bottom: 16px;
    }

.spabreaks .summary-section {
    margin-bottom: 10px;
  }

.spabreaks .booking-details {
    background-color: #1E5C5B;
    margin: 0 20px;
    max-width: 600px;
    color: white;
    font-weight: 200;
  }

.spabreaks .booking-details strong {
      font-weight: 600;
    }

.spabreaks .booking-details h2 {
      font-size: 2em;
      margin-bottom: .35em;
      line-height: 1.1;
    }

.spabreaks .booking-details p {
      margin-bottom: 0.15em;
    }

.spabreaks .booking-details .table-cell-right {
      width: auto;
      vertical-align: top;
    }

.spabreaks .booking-details .table-cell-right .print-button {
        line-height: normal;
        display: inline-block;
        border: 1px solid white;
        background: transparent;
        border-radius: 90px;
        padding: 0.5em 1em 0.5em 0.8em;
        margin-right: 10px;
      }

.spabreaks .booking-details .table-cell-right i {
        margin-right: 0.3em;
      }

.spabreaks .booking-details p.download-link {
      cursor: pointer;
      padding-top: 0.3em;
    }

.spabreaks .booking-details p.download-link.is-downloading {
          opacity: 0.8;
      }

.spabreaks .booking-details p.download-link i {
        margin-right: 0.5em;
      }

.spabreaks .booking-details p.download-link span {
        -webkit-text-decoration: underline;
        text-decoration: underline;
        text-underline-offset: 0.15em;
        font-size: 0.85em;
      }

.spabreaks .booking-details .pill {
      color: black;
      background: white;
      display: inline-block;
      padding: 3px 9px;
      border-radius: 5px;
      font-size: 0.9em;
      opacity: 0.95;
      margin-bottom: 18px;
    }

@media (min-width: 576px) {
  body {
    padding: 10px;
    font-size: 1.6rem;
  }

  h1 { font-size: 3.2rem; }
  h2 { font-size: 2.4rem; }
  h3 { font-size: 1.8rem; }
  h4 { font-size: 1.6rem; }
  h5 { font-size: 1.3rem; }
  h6 { font-size: 1rem; }

  .app {
    border-radius: 5px;
    border-radius: var(--border-radius-size);
  }

  .main {
    padding: 20px;
  }

  .main-header {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .itinerary-item {
    border-radius: 5px;
    border-radius: var(--border-radius-size);
  }
}

@media screen {
  body {
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    background-image: url("/assets/bg.jpg");
    background-image: var(--main-background);
  }
    .company-logo.dark {
      display: none;
    }

    .company-logo.light {
      display: block;
    }

  .app {
    background-color: #f2f5f8;
    background-color: var(--main-background-color);
    max-width: 640px;
    max-width: var(--container-width);
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
  }

  .main-header {
    background-image: linear-gradient(to bottom right, #268abe, #069);
    color: #fff;
    color: var(--alt-font-color);
    border-bottom: 10px solid #069;
  }

  .input {
    border: 1px solid #d7d7d7;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    border-radius: var(--border-radius-size);
  }

  .itinerary-item,
  .invoice-rate,
  .booking-details,
  .summary {
    padding: 20px;
    background-color: #fff;
    background-color: var(--itinerary-item-background-color);
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
  }

    .itinerary-item .confirmation-reference .input,.invoice-rate .confirmation-reference .input,.booking-details .confirmation-reference .input,.summary .confirmation-reference .input,.itinerary-item .rejection-reason .input,.invoice-rate .rejection-reason .input,.booking-details .rejection-reason .input,.summary .rejection-reason .input {
      display: block;
      width: 100%;
    }
}

@media print {
    .company-logo.dark {
      display: block;
    }

    .company-logo.light {
      display: none;
    }

  .toggle {
    display: none;
  }

  .input {
    margin-left: 20px;
    border: none;
  }

  .label,
  .input {
    display: inline-block;
  }

    .label .sub-label,.input .sub-label {
      display: none;
    }
    .rejection-reason .input {
      display: none;
    }

    .rejection-reason .printable-version {
      display: block;
    }

  .confirmation .selection .input,
  .confirmation .selection .label {
    display: inline-block;
  }

  .confirmation .unconfirm .input {
    margin: 0;
  }

  .confirmation .selection .label {
    border: 0;
  }

  .confirmation .selection:last-child .label {
    border-right: none;
  }

  .confirmation .selection.unconfirm .input:checked ~ .label,
  .confirmation .selection.reject .input:checked ~ .label,
  .confirmation .selection.confirm .input:checked ~ .label {
    background-color: inherit;
    border: 0;
    color: inherit;
  }

  .submit-confirmations {
    display: none;
  }

  .table-cell-right,
  .print-button,
  .user-guide {
    display: none !important;
  }
      .treatments table th,.treatments table td {
        background-color: #fff;
        background-color: var(--alt-font-color);
        color: #333;
        color: var(--font-color);
        border: 1px solid #333 !important;
        border: 1px solid var(--font-color) !important;
      }

      .treatments table th:nth-child(-n + 3) {
        border-right: 1px solid #333;
        border-right: 1px solid var(--font-color);
      }

  .booking-details {
    background: white !important;
    color: black !important;
    padding: 0 !important;
  }

  .inner-logo {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;;;;;;;;;;cAWY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;AASxB;;AAPE;IACE,aAAa;EACf;;AAEA;IACE,aAAa;EACf;;AAGF;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AAKpB;;AAHE;IACE,qBAAqB;EACvB;;AAGF;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;AAKnB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,kBAAwC;EAAxC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;AAgBZ;;AAdE;IACE,oCAAyC;IAAzC,yCAAyC;IACzC,kCAAmC;IAAnC,mCAAmC;EACrC;;AAEA;IACE,oCAAuC;IAAvC,uCAAuC;IACvC,kCAAiC;IAAjC,iCAAiC;EACnC;;AAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;AAGF;EACE,uBAAsB;EAAtB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAKhB;;AAHE;IACE,8BAA6B;IAA7B,6BAA6B;EAC/B;;AAGF;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAwC;EAAxC,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,YAAY;AAOd;;AALE;IACE,qBAAiC;IAAjC,iCAAiC;IACjC,sBAAsB;IACtB,WAAW;EACb;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AA0EpB;;AAvEI;MACE,cAAc;MACd,kBAAkB;MAClB,6BAAyC;MAAzC,yCAAyC;MACzC,gCAA4C;MAA5C,4CAA4C;MAC5C,8BAA0C;MAA1C,0CAA0C;MAC1C,eAAe;MACf,kBAAkB;MAClB,mBAAmB;IAKrB;;AAHE;QACE,yBAAmD;QAAnD,mDAAmD;MACrD;;AAGF;MACE,aAAa;IACf;;AAEA;MACE,2BAAiD;MAAjD,iDAAiD;MACjD,8BAAoD;MAApD,oDAAoD;IACtD;;AAEA;MACE,4BAAkD;MAAlD,kDAAkD;MAClD,+BAAqD;MAArD,qDAAqD;MACrD,+BAA2C;MAA3C,2CAA2C;IAC7C;;AAEA;MACE,WAA4B;MAA5B,4BAA4B;IAC9B;;AAEA;MACE,kCAAmC;MAAnC,mCAAmC;MACnC,kCAAwC;MAAxC,wCAAwC;IAC1C;;AAEA;MACE,kCAAmC;MAAnC,mCAAmC;MACnC,kCAAwC;MAAxC,wCAAwC;IAC1C;;AAEA;MACE,kCAAiC;MAAjC,iCAAiC;MACjC,kCAAsC;MAAtC,sCAAsC;IACxC;;AAEA;MACE,oCAAyC;MAAzC,yCAAyC;MACzC,kCAAmC;MAAnC,mCAAmC;MACnC,WAAwB;MAAxB,wBAAwB;IAC1B;;AAEA;MACE,oCAAyC;MAAzC,yCAAyC;MACzC,kCAAmC;MAAnC,mCAAmC;MACnC,WAAwB;MAAxB,wBAAwB;IAC1B;;AAEA;MACE,oCAAuC;MAAvC,uCAAuC;MACvC,kCAAiC;MAAjC,iCAAiC;MACjC,WAAwB;MAAxB,wBAAwB;IAC1B;;AAGF;IACE,YAAY;EACd;;AAGF;EACE,sBAAwD;EAAxD,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAwC;EAAxC,wCAAwC;AAa1C;;AAXE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;AAyBb;;AAvBE;IAEE,mBAAmB;EAerB;;AAbE;MACE,cAAc;MACd,iBAAiB;MACjB,uBAAkB;MAAlB,kBAAkB;MAClB,mBAAmB;IACrB;;AAEA;MACE,cAAc;MACd,iBAAiB;MACjB,eAAe;MACf,oBAAoB;IACtB;;AAGF;IACE,sBAAsB;IACtB,UAAU;EACZ;;AAGF;;;EAGE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;EAIE,mBAAmB;AAyDrB;;AAvDE;IACE,yBAA4B;IAA5B,4BAA4B;EAO9B;;AALE;MACE,iBAAiB;MACjB,cAAc;MACd,iBAAiB;IACnB;;AAGF;IACE,gCAAqD;IAArD,qDAAqD;IACrD,oBAAoB;IACpB,mBAAmB;EAarB;;AAXE;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;IACrB;;AAEA;MAEE,mBAAmB;IACrB;;AAGF;IACE,6BAAkD;IAAlD,kDAAkD;IAClD,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;AAEA;IAEE,mBAAmB;EACrB;;AAEA;IAKE,iBAAiB;EACnB;;AAEA;IACE,iBAAiB;EACnB;;AAEA;IACE,cAAc;EAChB;;AAGF;EACE,yBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gCAAqD;EAArD,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AAMb;;AAJE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;AAGF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAIE;IACE,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EA2ChB;;AAzCE;MACE,sBAAmC;MAAnC,mCAAmC;MACnC,WAA4B;MAA5B,4BAA4B;MAC5B,8BAA8B;IAChC;;AAEA;MAEE,yBAAyB;MACzB,iBAAiB;MACjB,mBAAmB;MACnB,cAAc;MACd,gBAAgB;IAClB;;AAEA;MACE,WAAW;IACb;;AAEA;MACE,yBAAyB;IAC3B;;AAEA;MACE,UAAU;IACZ;;AAEA;MACE,mBAAmB;IACrB;;AAFA;MACE,mBAAmB;IACrB;;AAFA;MACE,mBAAmB;IACrB;;AAEA;MACE,4BAA6C;MAA7C,6CAA6C;IAC/C;;AAFA;MACE,4BAA6C;MAA7C,6CAA6C;IAC/C;;AAFA;MACE,4BAA6C;MAA7C,6CAA6C;IAC/C;;AAEA;MAEE,yBAAyB;MACzB,uBAAsB;MAAtB,sBAAsB;MACtB,mCAAkC;MAAlC,kCAAkC;IACpC;;AALA;MAEE,yBAAyB;MACzB,uBAAsB;MAAtB,sBAAsB;MACtB,mCAAkC;MAAlC,kCAAkC;IACpC;;AALA;MAEE,yBAAyB;MACzB,uBAAsB;MAAtB,sBAAsB;MACtB,mCAAkC;MAAlC,kCAAkC;IACpC;;AALA;MAEE,yBAAyB;MACzB,uBAAsB;MAAtB,sBAAsB;MACtB,mCAAkC;MAAlC,kCAAkC;IACpC;;AAGF;IACE,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,cAAc;EAChB;;AAEA;IACE,iBAAiB;EACnB;;AAGF;EACE,WAAW;AACb;;AAGE;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;AAEA;IACE,kBAAkB;EACpB;;AAGF;EACE,iBAAiB;AAKnB;;AAHE;IACE;EACF;;AAIA;IACE,qBAAqB;EACvB;;AAEA;IACE,kBAAkB;EAKpB;;AAHE;MACE,SAAS;IACX;;AAIJ;EACE;AACF;;AAEA;EACE,iBAAiB;AAiBnB;;AAfE;IACE,mBAAmB;EACrB;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;;AAGF;EACE,iBAAiB;AAwGnB;;AAtGE;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,kBAAwC;IAAxC,wCAAwC;IACxC,kBAAkB;EAQpB;;AANE;MACE,kBAAkB;MAClB,UAAU;MACV,UAAU;MACV,iBAAiB;IACnB;;AAIA;MACE,YAAY;MACZ,UAAU;MACV,mBAAmB;IACrB;;AAGF;IACE,mBAAmB;EACrB;;AAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAgElB;;AA9DE;MACE,gBAAgB;IAClB;;AAEA;MACE,cAAc;MACd,oBAAoB;MACpB,gBAAgB;IAClB;;AAEA;MACE,qBAAqB;IACvB;;AAEA;MACE,WAAW;MACX,mBAAmB;IAerB;;AAbE;QACE,mBAAmB;QACnB,qBAAqB;QACrB,uBAAuB;QACvB,uBAAuB;QACvB,mBAAmB;QACnB,8BAA8B;QAC9B,kBAAkB;MACpB;;AAEA;QACE,mBAAmB;MACrB;;AAGF;MACE,eAAe;MACf,kBAAkB;IAepB;;AAbE;UACI,YAAY;MAChB;;AAEA;QACE,mBAAmB;MACrB;;AAEA;QACE,kCAA0B;QAA1B,0BAA0B;QAC1B,6BAA6B;QAC7B,iBAAiB;MACnB;;AAGF;MACE,YAAY;MACZ,iBAAiB;MACjB,qBAAqB;MACrB,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,mBAAmB;IACrB;;AAIJ;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA,KAAK,iBAAiB,EAAE;EACxB,KAAK,iBAAiB,EAAE;EACxB,KAAK,iBAAiB,EAAE;EACxB,KAAK,iBAAiB,EAAE;EACxB,KAAK,iBAAiB,EAAE;EACxB,KAAK,eAAe,EAAE;;EAEtB;IACE,kBAAwC;IAAxC,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,kBAAwC;IAAxC,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,uCAAwC;IAAxC,wCAAwC;EAC1C;IAGE;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;EAGF;IACE,yBAA8C;IAA9C,8CAA8C;IAC9C,gBAAiC;IAAjC,iCAAiC;IACjC,2CAAyC;EAC3C;;EAEA;IACE,iEAAiE;IACjE,WAA4B;IAA5B,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,yBAAqC;IAArC,qCAAqC;IACrC,kBAAwC;IAAxC,wCAAwC;EAC1C;;EAEA;;;;IAIE,aAAa;IACb,sBAAwD;IAAxD,wDAAwD;IACxD,2CAA0C;EAO5C;;IALE;MAEE,cAAc;MACd,WAAW;IACb;AAEJ;;AAEA;IAEI;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;;EAGF;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;;IAEE,qBAAqB;EAKvB;;IAHE;MACE,aAAa;IACf;IAIA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;EAGF;;IAEE,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,yBAAyB;IACzB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,wBAAwB;EAC1B;MAII;QACE,sBAAuC;QAAvC,uCAAuC;QACvC,WAAwB;QAAxB,wBAAwB;QACxB,iCAA8C;QAA9C,8CAA8C;MAChD;;MAEA;QACE,4BAAyC;QAAzC,yCAAyC;MAC3C;;EAIJ;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[":root {\n  --container-width: 640px;\n  --main-background-color: #f2f5f8;\n  --itinerary-item-background-color: #fff;\n  --font-color: #333;\n  --alt-font-color: #fff;\n  --main-background: url(\"/assets/bg.jpg\");\n  --amber: 255, 193, 7;\n  --light-amber: 252, 248, 227;\n  --dark-amber: 211, 158, 0;\n  --dark-gray: 169, 169, 169;\n  --green: 40, 167, 69;\n  --light-green: 190, 228, 199;\n  --dark-green: 30, 126, 52;\n  --red: 217, 83, 79;\n  --light-red: 242, 222, 222;\n  --dark-red: 139, 33, 30;\n  --border-color: #d7d7d7;\n  --selection-background-color: #f6f6f6;\n  --border-radius-size: 5px;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 62.5%;\n}\n\nh1 {\n  font-size: 2.4rem;\n  font-weight: normal;\n}\n\nh2 {\n  font-size: 1.8rem;\n  font-weight: normal;\n}\n\nh3 {\n  font-size: 1.6rem;\n  font-weight: normal;\n}\n\nh4 {\n  font-size: 1.3rem;\n  font-weight: normal;\n}\n\nh5 {\n  font-size: 1rem;\n  font-weight: normal;\n}\n\nh6 {\n  font-size: 0.8rem;\n  font-weight: normal;\n}\n\nbody {\n  font-family:\n    Lato,\n    system-ui,\n    BlinkMacSystemFont,\n    -apple-system,\n    \"Segoe UI\",\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    \"Fira Sans\",\n    \"Droid Sans\",\n    sans-serif;\n  font-size: 1.2rem;\n  line-height: 1.5em;\n  color: var(--font-color);\n}\n\n.company-logo {\n  display: block;\n  margin: 10px auto 30px;\n\n  &.light {\n    display: none;\n  }\n\n  &.dark {\n    display: none;\n  }\n}\n\n.app {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.content {\n  min-height: 95vh;\n}\n\n.content.error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n\n  h1 {\n    margin-bottom: 1.5rem;\n  }\n}\n\n.main-header {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-bottom: 3px solid #000;\n  min-height: 140px;\n\n  .subheader {\n    font-size: 1em;\n  }\n}\n\n.flash {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: 1rem 3rem;\n  border-radius: var(--border-radius-size);\n  max-width: 500px;\n  text-align: center;\n  transition: opacity 0.5s ease;\n  z-index: 1;\n\n  &.success {\n    background-color: rgb(var(--light-green));\n    border: 1px solid rgb(var(--green));\n  }\n\n  &.error {\n    background-color: rgb(var(--light-red));\n    border: 1px solid rgb(var(--red));\n  }\n\n  &.hidden {\n    opacity: 0;\n    pointer-events: none;\n  }\n}\n\n.input-error {\n  color: rgb(var(--red));\n}\n\n.list {\n  list-style-type: none;\n}\n\n.label .sub-label,\n.detail .sub-label {\n  font-size: 0.8em;\n  color: #999;\n}\n\n.label .sub-label.required {\n  color: #f00;\n}\n\n.input {\n  padding: 10px;\n  font-size: 1em;\n\n  &.error:not(:focus) {\n    border-color: rgb(var(--red));\n  }\n}\n\n.button {\n  display: block;\n  outline: none;\n  line-height: 3em;\n  padding-left: 2em;\n  padding-right: 2em;\n  border: 1px solid #4cae4c;\n  border-radius: var(--border-radius-size);\n  background: none;\n  background-color: #5cb85c;\n  text-transform: uppercase;\n  cursor: pointer;\n  color: white;\n\n  &:disabled {\n    border-color: var(--border-color);\n    background-color: #ccc;\n    color: #999;\n  }\n}\n\n.confirmation {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  overflow: hidden;\n  margin-bottom: 5px;\n\n  .selection {\n    .label {\n      display: block;\n      padding: 0.5em 1em;\n      border-top: 1px solid var(--border-color);\n      border-bottom: 1px solid var(--border-color);\n      border-left: 1px solid var(--border-color);\n      cursor: pointer;\n      text-align: center;\n      white-space: nowrap;\n\n      &:hover {\n        background-color: var(--selection-background-color);\n      }\n    }\n\n    .input {\n      display: none;\n    }\n\n    &:first-child .label {\n      border-top-left-radius: var(--border-radius-size);\n      border-bottom-left-radius: var(--border-radius-size);\n    }\n\n    &:last-child .label {\n      border-top-right-radius: var(--border-radius-size);\n      border-bottom-right-radius: var(--border-radius-size);\n      border-right: 1px solid var(--border-color);\n    }\n\n    .input:checked ~ .label {\n      color: var(--alt-font-color);\n    }\n\n    &.confirm .input:checked ~ .label {\n      background-color: rgb(var(--green));\n      border: 1px solid rgb(var(--dark-green));\n    }\n\n    &.unconfirm .input:checked ~ .label {\n      background-color: rgb(var(--amber));\n      border: 1px solid rgb(var(--dark-amber));\n    }\n\n    &.reject .input:checked ~ .label {\n      background-color: rgb(var(--red));\n      border: 1px solid rgb(var(--dark-red));\n    }\n\n    &.confirm .input:checked ~ .label:hover {\n      background-color: rgb(var(--light-green));\n      border: 1px solid rgb(var(--green));\n      color: var(--font-color);\n    }\n\n    &.unconfirm .input:checked ~ .label:hover {\n      background-color: rgb(var(--light-amber));\n      border: 1px solid rgb(var(--amber));\n      color: var(--font-color);\n    }\n\n    &.reject .input:checked ~ .label:hover {\n      background-color: rgb(var(--light-red));\n      border: 1px solid rgb(var(--red));\n      color: var(--font-color);\n    }\n  }\n\n  &.disabled {\n    opacity: 0.5;\n  }\n}\n\n.booking-alert-notice {\n  background-color: var(--itinerary-item-background-color);\n  padding: 20px;\n  margin-bottom: 20px;\n  border: 1px solid #dc3545;\n  border-radius: var(--border-radius-size);\n\n  &::before {\n    display: inline-block;\n    content: \"\\0021\";\n    border: 1px solid #dc3545;\n    color: #dc3545;\n    width: 1.5em;\n    height: 1.5em;\n    border-radius: 1em;\n    text-align: center;\n    margin-right: 10px;\n  }\n}\n\n.booking-details {\n  padding: 20px;\n}\n\n.table {\n  display: table;\n  width: 100%;\n\n  .table-cell,\n  .table-cell-right {\n    display: table-cell;\n\n    .user-guide {\n      display: block;\n      margin-left: auto;\n      width: fit-content;\n      margin-bottom: 20px;\n    }\n\n    .print-button {\n      font-size: 90%;\n      margin-left: auto;\n      margin-right: 0;\n      text-transform: none;\n    }\n  }\n\n  .table-cell-right {\n    vertical-align: bottom;\n    width: 35%;\n  }\n}\n\n.itinerary-item,\n.invoice-rate,\n.summary {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.itinerary-item,\n.invoice-rate,\n.booking-details,\n.summary {\n  margin-bottom: 20px;\n\n  &.cancelled {\n    color: rgb(var(--dark-gray));\n\n    .deleted-at-timestamp {\n      text-align: right;\n      font-size: 80%;\n      font-weight: bold;\n    }\n  }\n\n  .item-header {\n    border-bottom: 1px solid var(--main-background-color);\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n\n    .core-detail {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      margin-bottom: 10px;\n    }\n\n    .confirmation-reference .input,\n    .rejection-reason .input {\n      margin-bottom: 10px;\n    }\n  }\n\n  footer {\n    border-top: 1px solid var(--main-background-color);\n    font-size: 90%;\n    margin-top: 10px;\n    padding-top: 10px;\n  }\n\n  h3,\n  .section {\n    margin-bottom: 10px;\n  }\n\n  .guests h4,\n  .supplier-notes h4,\n  .medical-notes h4,\n  .treatments h4,\n  .meals h4 {\n    font-weight: bold;\n  }\n\n  .from-allocation {\n    font-weight: bold;\n  }\n\n  .block {\n    display: block;\n  }\n}\n\n.cancelled {\n  color: rgb(var(--dark-gray));\n}\n\n.supplier-prices {\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--main-background-color);\n}\n\n.supplier-price {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  .total {\n    padding-left: 20px;\n    text-align: right;\n  }\n}\n\n.loading {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.submit-confirmations {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.footer {\n  text-align: center;\n  padding-top: 10px;\n  padding-bottom: 20px;\n}\n\n.rejection-reason .printable-version {\n  display: none;\n}\n\n\n.treatments, .meals, .dinner-time {\n  table {\n    margin: 1em 0;\n    background-color: #f4f9f9;\n    border-collapse: collapse;\n    color: #838586;\n\n    th {\n      background-color: var(--font-color);\n      color: var(--alt-font-color);\n      border-bottom: none !important;\n    }\n\n    th,\n    td {\n      border: 1px solid #c4c8c9; \n      padding: 11px 8px;\n      vertical-align: top;\n      font-size: 90%;\n      line-height: 1.3;\n    }\n\n    td.full-width {\n      width: 100%;\n    }\n    \n    td.tbc {\n      background-color: #ffe5df;\n    }\n\n    td.zero-padding {\n      padding: 0;\n    }\n\n    td:nth-child(3) {\n      white-space: nowrap;\n    }\n\n    th:nth-child(-n+3) {\n      border-right: 1px solid var(--alt-font-color);\n    }\n\n    td.invalid,\n    td:has(input:invalid) {\n      background-color: #ffe5df;\n      color: rgb(var(--red));\n      border: 1px double rgb(var(--red));\n    }\n  }\n\n  input, select {\n    font-family: inherit;\n    font-size: inherit;\n    padding: 10px 8px;\n    background: none;\n    border: none;\n    color: inherit;\n  }\n\n  select {\n    margin-right: 8px;\n  }\n}\n\n.dinner-time table {\n  width: 100%;\n}\n\n.markdown {\n  h3 {\n    font-size: 1.6rem;\n    font-weight: 700 !important;\n  }\n\n  p, ul {\n    margin-bottom: 1em;\n  }\n}\n\n.heading {\n  font-weight: bold;\n\n  :first-child {\n    margin: 0\n  }\n}\n\n.guests, .markdown {\n  ul {\n    list-style-type: disc;\n  }\n\n  li {\n    margin-left: 1.6em;\n\n    p {\n      margin: 0;\n    }\n  }\n}\n\n.inner-logo {\n  display:none\n}\n\nbody:has(.spabreaks) {\n  padding-top: 20px;\n\n  .app {\n    background: #fbfaf8;\n  }\n\n  .company-logo {\n    display: none;\n  }\n\n  .inner-logo {\n    display: block;\n    left: -17px;\n    position: relative;\n    top: -13px;\n    margin-bottom: -8px;\n  }\n}\n\n.spabreaks {\n  padding-top: 20px;\n\n  h2 {\n    font-weight: 500;\n  }\n\n  h3 {\n    font-weight: 500;\n  }\n\n  .booking-details, .summary {\n    border-radius: var(--border-radius-size);\n    position: relative;\n\n    .download-print {\n      position: absolute;\n      width: 50%;\n      right: 6px;\n      text-align: right;\n    }\n  }\n\n  .summary {\n    .item-header {\n      border: none;\n      padding: 0;\n      margin-bottom: 16px;\n    }\n  }\n\n  .summary-section {\n    margin-bottom: 10px;\n  }\n\n  .booking-details {\n    background-color: #1E5C5B;\n    margin: 0 20px;\n    max-width: 600px;\n    color: white;\n    font-weight: 200;\n\n    strong {\n      font-weight: 600;\n    }\n\n    h2 {\n      font-size: 2em;\n      margin-bottom: .35em;\n      line-height: 1.1;\n    }\n\n    p {\n      margin-bottom: 0.15em;\n    }\n\n    .table-cell-right {\n      width: auto;\n      vertical-align: top;\n\n      .print-button {\n        line-height: normal;\n        display: inline-block;\n        border: 1px solid white;\n        background: transparent;\n        border-radius: 90px;\n        padding: 0.5em 1em 0.5em 0.8em;\n        margin-right: 10px;\n      }\n\n      i {\n        margin-right: 0.3em;\n      }\n    }\n\n    p.download-link {\n      cursor: pointer;\n      padding-top: 0.3em;\n\n      &.is-downloading {\n          opacity: 0.8;\n      }\n\n      i {\n        margin-right: 0.5em;\n      }\n\n      span {\n        text-decoration: underline;\n        text-underline-offset: 0.15em;\n        font-size: 0.85em;\n      }\n    }\n\n    .pill {\n      color: black;\n      background: white;\n      display: inline-block;\n      padding: 3px 9px;\n      border-radius: 5px;\n      font-size: 0.9em;\n      opacity: 0.95;\n      margin-bottom: 18px;\n    }\n  }\n}\n\n@media (width >= 576px) {\n  body {\n    padding: 10px;\n    font-size: 1.6rem;\n  }\n\n  h1 { font-size: 3.2rem; }\n  h2 { font-size: 2.4rem; }\n  h3 { font-size: 1.8rem; }\n  h4 { font-size: 1.6rem; }\n  h5 { font-size: 1.3rem; }\n  h6 { font-size: 1rem; }\n\n  .app {\n    border-radius: var(--border-radius-size);\n  }\n\n  .main {\n    padding: 20px;\n  }\n\n  .main-header {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n  }\n\n  .itinerary-item {\n    border-radius: var(--border-radius-size);\n  }\n}\n\n@media screen {\n  body {\n    background-size: cover;\n    background-position: center;\n    background-attachment: fixed;\n    background-image: var(--main-background);\n  }\n\n  .company-logo {\n    &.dark {\n      display: none;\n    }\n\n    &.light {\n      display: block;\n    }\n  }\n\n  .app {\n    background-color: var(--main-background-color);\n    max-width: var(--container-width);\n    box-shadow: 5px 5px 10px rgb(0 0 0 / 10%);\n  }\n\n  .main-header {\n    background-image: linear-gradient(to bottom right, #268abe, #069);\n    color: var(--alt-font-color);\n    border-bottom: 10px solid #069;\n  }\n\n  .input {\n    border: 1px solid var(--border-color);\n    border-radius: var(--border-radius-size);\n  }\n\n  .itinerary-item,\n  .invoice-rate,\n  .booking-details,\n  .summary {\n    padding: 20px;\n    background-color: var(--itinerary-item-background-color);\n    box-shadow: 5px 5px 10px rgba(0 0 0 / 10%);\n\n    .confirmation-reference .input,\n    .rejection-reason .input {\n      display: block;\n      width: 100%;\n    }\n  }\n}\n\n@media print {\n  .company-logo {\n    &.dark {\n      display: block;\n    }\n\n    &.light {\n      display: none;\n    }\n  }\n\n  .toggle {\n    display: none;\n  }\n\n  .input {\n    margin-left: 20px;\n    border: none;\n  }\n\n  .label,\n  .input {\n    display: inline-block;\n\n    .sub-label {\n      display: none;\n    }\n  }\n\n  .rejection-reason {\n    .input {\n      display: none;\n    }\n\n    .printable-version {\n      display: block;\n    }\n  }\n\n  .confirmation .selection .input,\n  .confirmation .selection .label {\n    display: inline-block;\n  }\n\n  .confirmation .unconfirm .input {\n    margin: 0;\n  }\n\n  .confirmation .selection .label {\n    border: 0;\n  }\n\n  .confirmation .selection:last-child .label {\n    border-right: none;\n  }\n\n  .confirmation .selection.unconfirm .input:checked ~ .label,\n  .confirmation .selection.reject .input:checked ~ .label,\n  .confirmation .selection.confirm .input:checked ~ .label {\n    background-color: inherit;\n    border: 0;\n    color: inherit;\n  }\n\n  .submit-confirmations {\n    display: none;\n  }\n\n  .table-cell-right,\n  .print-button,\n  .user-guide {\n    display: none !important;\n  }\n\n  .treatments {\n    table {\n      th, td {\n        background-color: var(--alt-font-color);\n        color: var(--font-color);\n        border: 1px solid var(--font-color) !important;\n      }\n\n      th:nth-child(-n+3) {\n        border-right: 1px solid var(--font-color);\n      }\n    }\n  }\n\n  .booking-details {\n    background: white !important;\n    color: black !important;\n    padding: 0 !important;\n  }\n\n  .inner-logo {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
